import React from "react";
import { AppNav } from "./AppNav.jsx";
import { AppHeader } from "./AppHeader.jsx";

import Help from "../static/Help.jsx";
import Privacy from "../static/Privacy.jsx";
import Dashboard from "../Dashboard.jsx";
import Account from "../Account.jsx";
import AddPanel from "../panel/AddPanel.jsx";
import { AddRelay } from "../relay/AddRelay.jsx";
import { ReauthPanel } from "../panel/ReauthPanel.jsx";

import { Redirect } from "react-router";
import { Route, Switch } from "react-router-dom";

import SiteManager from "../site/SiteManager.jsx";
import RelayEditor from "../relay/RelayEditor.jsx";
import PanelManager from "../panel/Manager.jsx";

const CUR_YEAR = new Date().getFullYear();
export function AppFrame(props) {
    return <div id="app-frame">
        <div id="wrap">
            <AppNav />
            <AppHeader location={props.location} />
            <Switch>
                <Route path="/help" component={Help} />
                <Route path="/privacy" component={Privacy} />
                <Route exact path="/" component={Dashboard} />
                <Route path="/account" component={Account} />

                <Route exact path="/site" render={() => <Redirect to="/" />} />

                <Route path="/relay/add" component={AddRelay} />
                <Route path="/relay/:id([0-9]+)" component={RelayEditor} />

                <Route path="/site/add" component={AddPanel} />
                <Route path="/site/reauth/:hwaddr([0-9a-f]{12})" component={ReauthPanel} />
                <Route path="/site/:hwaddr([0-9a-f]{12})/panel/:networkId([0-9]{1,2})" component={PanelManager} />
                <Route strict path="/site/:hwaddr([0-9a-f]{12})" component={SiteManager} />


                <Route render={() => <Redirect to ="/" />} />
            </Switch>
            <div id="push"></div>
        </div>
        <footer id="footer">
            <div className="container">
                <div className="row">
                    <div className="footer-copyright">
                        <p className="muted">
                            &copy; Zeta Alarms Ltd {CUR_YEAR} <br />
                            <small className="app-build-number">Build: {APP_BUILD_VERSION}</small>
                        </p>
                    </div>
                    <div className="footer-menu">
                        <ul>
                            <li><a href="#privacy">Privacy Policy</a></li>
                            <li><a href="#help">Help</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </div>
}